import { LOGO_PATHS } from "@client/app/icons/LogoIcon";

type LogoLoaderProps = React.SVGProps<SVGSVGElement>;

/** Logo mark with a light segment tracing its outline. Colour via `currentColor`. */
function LogoLoader(props: LogoLoaderProps) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			overflow="visible"
			role="status"
			aria-label="Loading"
			{...props}
		>
			<g className="opacity-20 motion-reduce:animate-pulse">
				{LOGO_PATHS.map((d) => (
					<path key={d} d={d} fill="currentColor" />
				))}
			</g>
			<g className="motion-reduce:hidden">
				{LOGO_PATHS.map((d) => (
					<path
						key={d}
						d={d}
						pathLength={1}
						stroke="currentColor"
						strokeWidth={1}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeDasharray="0.3 0.7"
						className="animate-logo-trace"
					/>
				))}
			</g>
		</svg>
	);
}

export default LogoLoader;
